import { h } from "preact";
import SwatchDetailsChip from "./swatch-details-chip";

export default function SwatchDetailsGrid({
  items,
  optionName,
  radioName,
  basket,
  limitEach,
  canAddMore,
  onSelect,
  onToggle,
  onQuantityChange,
}) {
  return (
    <fieldset className="swatch-details-drawer__grid">
      <legend className="visually-hidden">{optionName}</legend>
      {items.map((item) => {
        const variantId =
          item.swatchProduct && window.gidToId(item.swatchProduct.variantId);

        return (
          <SwatchDetailsChip
            key={item.optionValueName}
            item={item}
            radioName={radioName}
            quantity={(variantId && basket[variantId]) || 0}
            limitEach={limitEach}
            canAddMore={canAddMore}
            onSelect={onSelect}
            onToggle={() => onToggle(variantId)}
            onQuantityChange={(quantity) =>
              onQuantityChange(variantId, quantity)
            }
          />
        );
      })}
    </fieldset>
  );
}
